export interface UserStatus {
	email: string | null;
	emailAttached: boolean;
	emailCertificateReady: boolean;
	emailEvidenceFreshUntil: string | null;
	emailEvidenceStatus: "missing" | "ready" | "stale";
	emailVerified: boolean;
	onboarding_completed: boolean;
}

/**
 * Fetch the current user's onboarding/email status from the database-backed API.
 * This must bypass browser caches so auth redirects never rely on stale state.
 */
export async function fetchUserStatus(): Promise<UserStatus | null> {
	const response = await fetch("/api/user/status", {
		credentials: "include",
		cache: "no-store",
		headers: {
			"cache-control": "no-store",
		},
	});

	if (!response.ok) {
		return null;
	}

	const json = (await response.json()) as {
		data?: UserStatus;
	};

	return json.data ?? null;
}
